import { map } from 'lodash'
import { all, put, select, takeLatest } from 'redux-saga/effects'

import { landingPage as landingActions } from '../constants/actions'
import { files, landingPage } from '../constants/endpoints'
import { getLandingPageSubdomain } from '../selectors'
import { getSubdomain as getSubdomainPath } from '../utils/common'
import { get } from '../utils/request'

function* getLandingPage() {
  const subdomain = yield select(getLandingPageSubdomain)
  const sd = getSubdomainPath()
  const response = yield get({
    endpointId: landingPage.getLandingPage,
    params: { subdomain: subdomain || sd },
  })
  let settings = response.data
  let headerLogo
  let landingPageImage
  let landingPageLogo
  let eventLogo

  try {
    /* eslint-disable prefer-destructuring */
    headerLogo = settings.displaySetting.headerLogo
    landingPageImage = settings.displaySetting.landingPageImage
    landingPageLogo = settings.displaySetting.landingPageLogo
    eventLogo = settings.event.logo.eventLogo
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('Error: ', error)
  }
  /* eslint-enable prefer-destructuring */
  if (settings) {
    const images = yield processImages({
      headerLogo,
      landingPageImage,
      landingPageLogo,
      eventLogo,
    })

    const links = {}
    settings.sponsors.forEach(s => {
      links[s.id] = s.file
    })
    const sponsors = yield processImages(links)

    settings = {
      ...settings,
      ...images,
      sponsorLogos: {
        ...sponsors,
      },
    }
    yield put(landingActions.setLandingPage(settings))
  } else {
    yield put(landingActions.getLandingPageError())
  }
}

function* processImages(links) {
  const keys = []
  const sagas = map(links, (v, k) => {
    keys.push(k)
    return get({
      endpointId: files.download,
      params: {
        key: v,
        isImage: true,
      },
    })
  })
  const response = yield all(sagas)
  const images = keys.reduce((a, v, i) => {
    const image = response[i].data
    // eslint-disable-next-line no-param-reassign
    a[v] = image
    return a
  }, {})
  return images
}

export function* runLandingPageSagas() {
  yield takeLatest(landingActions.GET_LANDING_PAGE, getLandingPage)
}
